export default "/fonts/hotelspace.woff2?fcdaa7d9090bc05c4334d117a130ad01";